import * as firebase from 'firebase/app';


const firebaseConfig ={
  apiKey: "AIzaSyAfHQzcW_ERhOMvjSlZljXgBfmO-J3bMbw",
  authDomain: "donggubat-ead44.firebaseapp.com",
  databaseURL: "https://donggubat-ead44.firebaseio.com",
  projectId: "donggubat-ead44",
  storageBucket: "donggubat-ead44.appspot.com",
  messagingSenderId: "974902710947",
  appId: "1:974902710947:web:13fb330bcf9662b3d3e516"
};

firebase.initializeApp(firebaseConfig);

export default firebase;